import React from 'react';
import Avatar from './Avatar';
import SectionCard from './SectionCard';

function fullName(user) {
  if (!user) return '';
  return [user.prenom, user.nom].filter(Boolean).join(' ').trim();
}

export default function ProfileCard({ user, onEdit }) {
  const name = fullName(user) || 'Mon compte';

  return (
    <SectionCard
      action={
        <button type="button" onClick={onEdit} style={styles.editBtn} aria-label="Modifier mon profil">
          Modifier
        </button>
      }
    >
      <div style={styles.row}>
        <Avatar name={name} size={52} />
        <div style={styles.body}>
          <div style={styles.name}>{name}</div>
          <div style={styles.role}>Restaurateur</div>
          {user?.email && <div style={styles.email}>{user.email}</div>}
        </div>
      </div>
    </SectionCard>
  );
}

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  name: {
    fontSize: 17,
    fontWeight: 700,
    color: '#1A1A1A',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  role: {
    fontSize: 13,
    color: '#6B6B6B',
    marginTop: 2,
  },
  email: {
    fontSize: 12,
    color: '#9A9A9A',
    marginTop: 4,
  },
  editBtn: {
    background: 'transparent',
    border: '1px solid #E5E5E0',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 13,
    fontWeight: 600,
    color: '#1A1A1A',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
};
